import templateStr from 'text!./templates/confirmation.html';
import 'edge/quoteandbind/common/app';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/directives/Confirmation.js
// module id = 1216
// module chunks = 0